import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-h3 md:!text-h3" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const H3 = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <h3 data-testid={testId} className={base({ className })}>
      {children}
    </h3>
  );
};

export default H3;
